export default "__VITE_ASSET__SkHhcBM2__"